import {
  DEACTIVATE_CALIB_SUCCESS,
  DEACTIVATE_CALIB_FAIL,
  CREATE_CALIB_FAIL,
  CREATE_CALIB_SUCCESS,
  LIST_CALIB_FAIL,
  LIST_CALIB_SUCCESS,
  ONE_CALIB_FAIL,
  ONE_CALIB_SUCCESS,
  ME_CALIB_SUCCESS,
  ME_CALIB_FAIL,
  SEARCH_CALIB_SUCCESS,
  SEARCH_CALIB_FAIL,
  LIST_CALIB_DESACTIVER_SUCCESS,
  LIST_CALIB_DESACTIVER_FAIL,
  CHANGER_ACCES_CALIB_SUCCESS,
  CHANGER_ACCES_CALIB_FAIL,
  RESET_STATUS_LIST,
} from "../../actions/calibrage/type";

const initialState = {
  datacalibs: {},
  datacalib: {},
  accescalib: null,
  datamecalibs: [],
};
const calibReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LIST_CALIB_SUCCESS:
      return {
        ...state,
        datacalibs: payload,
      };
    case LIST_CALIB_FAIL:
      return {
        ...state,
      };
    case ME_CALIB_SUCCESS:
      return {
        ...state,
        datacalibs: payload,
      };
    case ME_CALIB_FAIL:
      return {
        ...state,
      };
    case ONE_CALIB_SUCCESS:
      return {
        ...state,
        datacalib: payload,
      };
    case ONE_CALIB_FAIL:
      return {
        ...state,
      };
    case CREATE_CALIB_SUCCESS:
      return {
        ...state,
        datacalib: payload,
      };
    case CREATE_CALIB_FAIL:
      return {
        ...state,
      };
    case SEARCH_CALIB_SUCCESS:
      return {
        ...state,
        datacalibs: payload,
      };
    case SEARCH_CALIB_FAIL:
      return {
        ...state,
      };
    case LIST_CALIB_DESACTIVER_SUCCESS:
      return {
        ...state,
        datacalibs: payload,
      };
    case LIST_CALIB_DESACTIVER_FAIL:
      return {
        ...state,
      };
    case DEACTIVATE_CALIB_SUCCESS:
      return {
        ...state,
        datacalibs: payload,
      };
    case DEACTIVATE_CALIB_FAIL:
      return {
        ...state,
        // idg: payload.id,
      };
    case CHANGER_ACCES_CALIB_SUCCESS:
      return {
        ...state,
        accescalib: payload,
      };
    case CHANGER_ACCES_CALIB_FAIL:
      return {
        ...state,
      };
    case RESET_STATUS_LIST:
      return {
        ...state,
        statusList: [],
      };
    default:
      return state;
  }
};

export default calibReducer;
